<template>
  <div>
    <h1 class="page-header">{{ $t('jobTitle.pageTitle') }}</h1>
    <div>
      <ts-card>
        <ts-card-wrapper>
          <div class="d-flex justify-content-between">
            <ts-button color="info" outline @click="showForm()">{{ $t('addNew') }}</ts-button>
            <ts-input v-model="search" :placeholder="$t('search')" style="width: 300px;" />
          </div>
        </ts-card-wrapper>
        <ts-table :columns="columns" :records="resources" :loading="loading">
          <template v-slot="{ record }">
            <td>{{ record.job_title_kh }}</td>
            <td>{{ record.job_title_en }}</td>
            <td class="text-center">
              <a href="#" v-tooltip="'Edit'" class="text-primary mr-2" @click.prevent="edit(record)">
                <i class="fas fa-edit"></i>
              </a>
              <a
                href="#"
                v-tooltip="'Delete'"
                class="text-danger"
                @click.prevent="destroy(record)"
                :disabled="record._deleting"
              >
                <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                <i class="fas fa-trash" v-else></i>
              </a>
            </td>
          </template>
        </ts-table>
        <div class="d-flex justify-content-end p-15">
          <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
        </div>
      </ts-card>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormComponent from './form.vue'

export default {
  name: 'job-title',
  components: { FormComponent },
  data() {
    return {
      loading: false
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('hr/jobTitle', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.hr.jobTitle.search
      },
      set(newValue) {
        this.$store.commit('hr/jobTitle/SET_SEARCH', newValue)
        this.$store.commit('hr/jobTitle/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        {
          name: this.$t('jobTitle.jobTitleKh'),
          sortKey: 'job_title_kh'
        },
        {
          name: this.$t('jobTitle.jobTitleEn'),
          sortKey: 'job_title_en'
        },
        { name: this.$t('actions'), style: 'text-align:center; width: 1px;' }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('hr/jobTitle/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
      this.showForm(record)
    },
    async destroy(record) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        record._deleting = true
        this.$store
          .dispatch('hr/jobTitle/destroy', record.job_title_id)
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    },
    showForm(editData) {
      this.$modal.show(
        FormComponent,
        {
          editData: editData
        },
        {
          height: 'auto',
          width: '400px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('hr/jobTitle/RESET_STATE')
    next()
  }
}
</script>
